import LeadershipProfile from "../../components/LeadershipProfile"
import SEO from "../../components/SEO";

export default function SeniorManagement() {
  const seniorManagementSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Senior Management",
    "url": "https://www.thrombio.com.au/leadership/senior-management",
    "mainEntity": {
      "@type": "Organization",
      "name": "Thrombio",
      "url": "https://www.thrombio.com.au/",
      "logo": "https://www.thrombio.com.au/thromBioInvert.png",
      "contactPoint": {
        "@type": "ContactPoint",
        "email": "info@thrombio.com.au"
      },
      "sameAs": [
        "https://www.linkedin.com/company/thrombioholdings"
      ]
    },
    "about": {
      "@type": "Organization",
      "name": "Thrombio",
      "description": "Thrombio is a drug discovery company dedicated to advancing the global standard of care for the treatment of stroke using novel anti-thrombotic drugs with unprecedented safety and efficacy."
    }
  };

  return (
    <div className="seniorManagementBg">
      <SEO
        title="Senior Management"
        description="Learn about our team of international leaders in stroke clinical trials, scientists with extensive drug development experience and businesspeople with more than 30 years' experience"
        keywords={['Leadership Team', 'Management', 'Peter Bush', 'Dr. Sundeep Dugar', 'Simone Schoenwaelder', 'Amos Meltzer']}
        ogImage="/peterBush.webp"
        schema={seniorManagementSchema}
      />

      <div className="px-12 pt-40 md:pt-[150px] xl:pt-[186px] xl:page-width xl:px-0">
        <div className="flex flex-col gap-4 md:gap-16">
          {/* Optimized H1 tag that preserves layout */}
          <div className="text-[4.8rem] font-bold leading-[5.2rem] tracking-[.19rem] drop-shadow-[0_4px_8.9px_#000]">
            <h1 className="sr-only">ThromBio Senior Management: Leading Experts in Stroke Therapy</h1>
            Leadership
          </div>
          {/* Optimized H2 tag that preserves layout */}
          <div className="drop-shadow-[0_4px_8.9px_#000] font-syne text-[3rem] font-bold leading-[3.6rem] tracking-[.15rem]">
            <h2 className="sr-only">Our Senior Management Team: Pioneers in Stroke Treatment</h2>
            Senior Management
          </div>
        </div>
      </div>
	  <div className="pt-[130px] xl:pt-[90px] xl:pb-[320px] px-16 xl:px-[158px] 2xl:px-[450px] flex flex-col xl:grid grid-cols-2 items-center xl:items-start gap-[115px] md:gap-[75px] seniorManagementBg2">
          <div>
            {/* Updated title with sr-only optimization to preserve layout */}
            <LeadershipProfile
              name="Peter Bush"
              title={<>Chief Executive Officer <span className="sr-only">: Executive and Investor in Healthcare and Technology Sectors</span></>}
              description="With over 2 decades of senior leadership and board experience, Peter Bush is an executive, investor, mentor and director, with a focus on the healthcare and technology sectors.
Peter has a proven track record of driving growth, innovation, and commercialization in various public and private entities across Australia, USA, Europe, and Asia. He has extensive expertise in mergers and acquisitions, joint ventures, cross border trade, technology licensing, regulatory compliance and risk management. He is experienced in new business development, venture capital/private equity funding, and technology commercialization.
He holds a Bachelor of Commerce from Macquarie University and a Graduate Diploma in Chartered Accounting from the Institute of Chartered Accountants in Australia."
              image="/peterBush.webp"
            />
          </div>
          <img src="/1.2.svg" alt="Decorative divider" width={23} height={14} className="xl:hidden" />
          <div className="">
            {/* Updated title with sr-only optimization to preserve layout */}
            <LeadershipProfile
              name="Dr. Sundeep Dugar"
              title={<>Drug Discovery <span className="sr-only">: Renowned Leader in Oncology, Cardiovascular, and Metabolic Drug Development</span></>}
              description="Dr. Sundeep Dugar (drug discovery) has over 30 years of experience in drug discovery and development across oncology, cardiovascular, and metabolic diseases. He has held leadership roles at Schering-Plough, Bristol-Myers Squibb, and Johnson & Johnson, where he played a key role in the $2.4 billion acquisition of Scios and the licensing of Xarelto. A co-inventor of the blockbuster drugs Zetia® and Vytorin®, he has received prestigious awards for his contributions to chemistry and pharmaceuticals. Dr. Dugar holds a Ph.D. from UC Davis and completed postdoctoral research at ETH Zurich and Cornell University."
              image="/sundeepDugar.webp"
            />
          </div>
          <img src="/1.2.svg" alt="Decorative divider" width={23} height={14} className="xl:hidden" />
          <div className="">
            {/* Updated title with sr-only optimization to preserve layout */}
            <LeadershipProfile
              name="Simone Schoenwaelder"
              title={<>Head, Biology <span className="sr-only">: Experienced Medical Researcher in Blood Clotting and Platelet Biology</span></>}
              description="Simone has >25 years experience in medical research, working in the field of cell biology, namely platelet biology and function. After receiving her doctorate from Monash University (Victoria), she completed postdoctoral at the University of North Carolina (Chapel Hill) with Professor Keith Burridge, supported by an NHMRC CJ Martin Fellowship. Her research has been continually funded through competitive grants from the NHMRC, NHF and Department of Health (NSW). She has received numerous awards throughout her career, including a Victorian Premier's Award for Medical Research Commendation (1997); Young Australian of the Year - State winner, for science and technology (Victoria, 1999) and National Finalist, Young Australian of the Year (1999); City of Whitehorse Young Citizen of the Year (1999); and the THANZ Scientific Medal awarded by the Thrombosis and Haemostasis society of Australia and New Zealand in 2007."
              image="/simoneSchoenwaelder.webp"
            />
          </div>
          <img src="/1.2.svg" alt="Decorative divider" width={23} height={14} className="xl:hidden" />
          <div className="">
            {/* Updated title with sr-only optimization to preserve layout */}
            <LeadershipProfile
              name="Amos Meltzer"
              title={<>Corporate Development <span className="sr-only">: Expert in Life Sciences, Intellectual Property, and Technology Commercialisation</span></>}
              description="Amos Meltzer (corporate development) is a seasoned life sciences executive, intellectual property lawyer, and technology commercialisation expert with over 25 years of experience in biotechnology, pharmaceuticals, and medical devices. He has held key leadership roles, including COO at Synchron, Non-Executive Director at Paradigm Biopharmaceuticals, and Chairman of Maverick Life Sciences.
Amos has successfully led clinical development, secured funding, and negotiated high-value commercial agreements for ASX and Nasdaq-listed companies. With a strong legal and business background, he has played a pivotal role in bringing innovative medical technologies to market, making him a trusted leader in the life sciences industry."
              image="/amosMeltzer.webp"
            />
          </div>
        </div>
    </div>
  );
}